import React from 'react'
import { IoMdClose } from 'react-icons/io'

import { sampleProducts } from '../lib/FakeData'
import ProductCart from './ProductCart'
import { useDispatch, useSelector } from 'react-redux'
import { removeFromCart } from '../redux/Actions/CartActions'
import { formatNumber, rateUsdt } from '../service'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { BuyNowButton } from './BuyNowButton'

export const CartDrawer = ({ setOpen }) => {
    const dispatch = useDispatch();

    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;

    const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);
    const removeFromCartHandler = (id) => {

        dispatch(removeFromCart(id));
    };
    return (
        <div className='h-screen w-full'>
            <div className="py-2 px-4 h-[50px] flex justify-between items-center bg-[--color-button-3]">

                <p className='text-white'>Giỏ hàng của bạn</p>
                <button
                    className='text-white'
                    onClick={() => setOpen(false)}
                >
                    <IoMdClose />
                </button>
            </div>
            <div className='py-2 px-4 h-[calc(100%-200px)] overflow-y-scroll no-scrollbar '>
                {cartItems?.map((value, index) => {
                    return <ProductCart key={index} product={value} removeCart={removeFromCartHandler} />
                })}
            </div>
            <div className=" h-[150px] flex flex-col justify-center items-center gap-4 w-full bg-[--color-button-1]">
                <div className=' grid grid-cols-2 w-full justify-between border-b py-2 px-4'>
                    <div className='flex flex-col font-bold items-start text-sm gap-1'> <span>Tổng sản phẩm</span> <span>{(Number(cartItems.length)).toFixed(0)}</span></div>
                    <div className='flex flex-col font-bold items-end text-sm gap-1'> <span>Tổng tiền</span>
                        <div className="flex gap-2 text-[--color-button-3]">
                            <img src="/images/logoToken.png" style={{ width: 20 }} /> {(Number(total)).toFixed(2)} <span className="text-black">({formatNumber(total * rateUsdt)}đ)</span>
                        </div>
                    </div>

                </div>

                <div className='flex justify-between items-center w-[80%] py-2 px-4'>
                    <Link to={"/cart"} className='bg-[--color-button-3] w-auto px-6 py-2 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200
                ' onClick={()=>setOpen(false)}>Xem giỏ hàng</Link>
                   <BuyNowButton className={"!m-0 !px-6"} />
                </div>
            </div>
        </div>
    )
}
